import React from 'react';
import { loader, loader_mask } from './loader.module.scss';

export const Loader = () => (
  <div className={loader_mask}>
    <div className={loader}>Loading...</div>
  </div>
);
